import styled from "styled-components";
import { FormWrapper, OrangeAccentCard } from "../../styles/shared";

export const ProfileWrapper = styled.div`
  background: #0a0e27;
  min-height: 100vh;
  position: relative;
  margin: calc(-24px - 1.5rem - 4.375rem) -24px 0 -24px;
  padding-top: calc(4.375rem + 1.5rem);
`;

export const PageHeader = styled.div`
  position: relative;
  z-index: 1;
  padding: 16px 0 0 0;
  margin-bottom: 24px;
  
  @media (min-width: 768px) {
    padding: 24px 0 0 0;
    margin-bottom: 32px;
  }
  
  h1 {
    color: #ffffff;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    
    @media (min-width: 768px) {
      font-size: 32px;
      gap: 12px;
    }
    
    i {
      color: #f29205;
      font-size: 28px;
      text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
      
      @media (min-width: 768px) {
        font-size: 36px;
      }
    }
  }
`;

export const ProfileCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px !important;
  
  @media (min-width: 768px) {
    padding: 32px !important;
  }
`;

export const CardTitle = styled.div`
  color: #f29205;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);
  
  @media (min-width: 768px) {
    font-size: 20px;
    margin-bottom: 24px;
    gap: 10px;
  }
  
  i {
    font-size: 20px;
    color: #ff6b35;
    filter: drop-shadow(0 0 5px rgba(255, 107, 53, 0.5));
    
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
`;

export const ContentArea = styled.div`
  position: relative;
  z-index: 1;
  padding: 16px 16px 0 16px;
  
  @media (min-width: 768px) {
    padding: 24px 24px 0 24px;
  }
  
  @media (min-width: 1200px) {
    padding: 24px 72px 0 72px;
  }
`;

export const PhotoSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 20px;
  flex-wrap: wrap;
  
  @media (min-width: 768px) {
    align-items: center;
    padding: 20px 0;
    margin-top: 24px;
  }
`;

export const PhotoPreview = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid rgba(242, 146, 5, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.05);
  flex-shrink: 0;
  
  @media (min-width: 768px) {
    width: 120px;
    height: 120px;
    border: 3px solid rgba(242, 146, 5, 0.3);
  }
  
  &:hover {
    border-color: rgba(242, 146, 5, 0.6);
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(242, 146, 5, 0.3);
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  i {
    @media (max-width: 767px) {
      font-size: 36px !important;
    }
  }
`;

export const PhotoInfo = styled.div`
  flex: 1;
  min-width: 200px;
  width: 100%;
  
  @media (max-width: 767px) {
    min-width: 100%;
  }
  
  .photo-label {
    color: #b0b0b0;
    font-size: 13px;
    margin-bottom: 8px;
    display: block;
    
    @media (min-width: 768px) {
      font-size: 14px;
    }
  }
  
  input[type="file"] {
    color: #e0e0e0;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    
    @media (min-width: 768px) {
      font-size: 14px;
    }
    
    &:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(242, 146, 5, 0.3);
    }
    
    &::file-selector-button {
      background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
      color: #ffffff;
      border: none;
      padding: 6px 12px;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      margin-right: 8px;
      transition: all 0.3s ease;
      font-size: 12px;
      white-space: nowrap;
      
      @media (min-width: 768px) {
        padding: 8px 16px;
        margin-right: 12px;
        font-size: 14px;
      }
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(242, 146, 5, 0.4);
      }
    }
    
    &::-webkit-file-upload-button {
      background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
      color: #ffffff;
      border: none;
      padding: 6px 12px;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      margin-right: 8px;
      font-size: 12px;
      
      @media (min-width: 768px) {
        padding: 8px 16px;
        margin-right: 12px;
        font-size: 14px;
      }
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  
  @media (min-width: 768px) {
    margin-top: 32px;
    padding-top: 24px;
  }
  
  button,
  .mobile-button {
    @media (max-width: 767px) {
      width: 100% !important;
      justify-content: center !important;
      padding: 10px 20px !important;
      font-size: 14px !important;
      height: 44px !important;
      min-height: 44px !important;
      max-height: 44px !important;
      
      & > span {
        font-size: 14px !important;
      }
      
      svg {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }
`;

export const StyledFormWrapper = styled(FormWrapper)`
  @media (max-width: 767px) {
    .MuiFormControl-root {
      .MuiOutlinedInput-root {
        height: 48px !important;
        min-height: 48px !important;
        
        .MuiInputBase-input {
          height: 48px !important;
          padding: 12px 14px !important;
          font-size: 14px !important;
        }
      }
      
      .MuiInputLabel-root {
        font-size: 14px !important;
      }
    }
  }
`;

// Exportando FormWrapper compartilhado
export { FormWrapper };





